import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { IImage } from './image.interface';

@Component({
    selector: 'mlp-ng-image',
    templateUrl: './image.component.html',
    styleUrls: ['./image.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})

export class ImageSharedComponent {
    srcset: string;
    defaultImg: string;

    @Input() title: string;
    @Input() alt: string;
    @Input() set image(image: IImage) {
        if (image) {
            this.defaultImg = image.large[0];
            this.srcset = `${image.small[0]} 400w, ${image.medium[0]} 640w, ${image.large[0]} 1024w`;
        }
    }
}
